module.exports = __webpack_public_path__ + "static/media/16.5baa18f0.jpg";